// @flow

// target company stock
export const UPDATE_TARGET_STOCK = 'stock:updateTargetStock'
export type UPDATE_TARGET_STOCK_TYPE = {
  type: 'stock:updateTargetStock',
  payload: { 
    targetStockHistory: Object[],
    symbol: string
  }
}

export const updateTargetStock = (targetStockHistory: Object[], symbol: string): UPDATE_TARGET_STOCK_TYPE => ({
  type: UPDATE_TARGET_STOCK,
  payload: {
    targetStockHistory,
    symbol
  }
})

// status of fetching data
export const UPDATE_STOCK_STATUS = 'stock:updateStockStatus'
export type UPDATE_STOCK_STATUS_TYPE = {
  type: 'stock:updateStockStatus',
  payload: {
    isFetching: boolean,
    error: null | string,
    symbol: string
  }
}

export const updateStockStatus = (isFetching: boolean, error: null | string, symbol: string): UPDATE_STOCK_STATUS_TYPE => ({
  type: UPDATE_STOCK_STATUS,
  payload: {
    isFetching,
    error,
    symbol
  }
})

// get stock history by symbol and time
export const getCompanyStock = (dispatch: Function, symbol: string, time: string) => {

  // set status fetching: true, error: null
  dispatch(updateStockStatus(true, null, symbol))

  // get IEX data
  fetch(`https://cloud.iexapis.com/v1/stock/${symbol}/chart/${time}?token=pk_ff59a3b39cf04827aed30a4797e5a6f0`)
    .then((res: Object) => res.json())
    .then((res: Object[]) => {

      // set status fetching: false, error: null
      dispatch(updateStockStatus(false, null, symbol))

      // set stock data
      dispatch(updateTargetStock(res, symbol))
    })
    .catch((err: Object) => {

      // set status fetching: false, error: msg
      dispatch(updateStockStatus(false, `Unable to Get Stock Data for ${symbol}`, symbol))
    })
}



// WEBPACK FOOTER //
// ./src/actions/stock/index.js